import firebase from "firebase/app";

import { tRep, validate } from "tmt_api/src/types/types.validator";

export const documentRep = (id: string): firebase.firestore.DocumentReference<tRep> =>
  firebase
    .firestore()
    .collection("reps")
    .doc(id)
    .withConverter<tRep>({
      toFirestore: (data) => data,
      fromFirestore: (snapshot) => validate("tRep")(snapshot.data()),
    });
